import { createSelector } from 'reselect'

import { selectCockpitPeriods } from './selectCockpitPeriods'

/** Whether the dashboard is scoped to the full fiscal year, as opposed to a quarter combination
 *  or YTD. Gates the Revenue & SOB / Plan Quality table switch — plan quality figures only make
 *  sense against a full year. */
export const selectIsCockpitFullYear = createSelector([selectCockpitPeriods], (periods) =>
  periods.includes('fullYear')
)
